var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{class:_vm.outlined ? `material-icons-outlined` : `material-icons`,attrs:{"aria-hidden":"true"}},[_vm._v(" "+_vm._s(_vm.name)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }